module.exports = __webpack_public_path__ + "img/project-nonconformities.d04e5d7c.svg";